import andrew_huang_music from "./andrew-huang-music.json";
import awards_season_filmmaking_challenge from "./awards-season-filmmaking-challenge.json";
import beatmaking_challenge from "./beatmaking-challenge.json";
import blanks_music from "./blanks-music.json";
import casey_neistat_filmmaking from "./casey-neistat-filmmaking.json";
import charlie_puth_music from "./charlie-puth-music.json";
import christina_tosi_baking from "./christina-tosi-baking.json";
import covers_challenge from "./covers-challenge.json";
import daria_callie_portrait from "./daria-callie-portrait.json";
import david_blaine_magic from "./david-blaine-magic.json";
import general_faq from "./general-faq.json";
import general from "./general.json";
import her_songwriting from "./her-songwriting.json";
import holiday_baking_challenge from "./holiday-baking-challenge.json";
import holiday_build_challenge from "./holiday-build-challenge.json";
import ingredient_inspired_recipe_challenge from "./ingredient-inspired-recipe-challenge.json";
import kygo_music from "./kygo-music.json";
import kyle_hanagami_dance from "./kyle-hanagami-dance.json";
import louis_bell_production from "./louis-bell-production.json";
import mark_rober_engineering from "./mark-rober-engineering.json";
import pasek_paul_musical_theatre from "./pasek-paul-musical-theatre.json";
import pentatonix_a_cappella from "./pentatonix-a-cappella.json";
import ryan_tedder_songwriting from "./ryan-tedder-songwriting.json";
import shoe_surgeon_shoemaking from "./shoe-surgeon-shoemaking.json";
import simone_giertz_building from "./simone-giertz-building.json";
import stevie_mackey_singing from "./stevie-mackey-singing.json";
import ten_hundred_painting from "./ten-hundred-painting.json";
import valentines_day_baking_challenge from "./valentines-day-baking-challenge.json";
import valentines_day_love_song_challenge from "./valentines-day-love-song-challenge.json";
import vlogging_challenge from "./vlogging-challenge.json";

const FAQ_CONTENT = {
  general,
  "general-faq": general_faq,
  "andrew-huang-music": andrew_huang_music,
  "awards-season-filmmaking-challenge": awards_season_filmmaking_challenge,
  "beatmaking-challenge": beatmaking_challenge,
  "blanks-music": blanks_music,
  "casey-neistat-filmmaking": casey_neistat_filmmaking,
  "charlie-puth-music": charlie_puth_music,
  "christina-tosi-baking": christina_tosi_baking,
  "covers-challenge": covers_challenge,
  "daria-callie-portrait": daria_callie_portrait,
  "david-blaine-magic": david_blaine_magic,
  "her-songwriting": her_songwriting,
  "holiday-baking-challenge": holiday_baking_challenge,
  "holiday-build-challenge": holiday_build_challenge,
  "ingredient-inspired-recipe-challenge": ingredient_inspired_recipe_challenge,
  "kygo-music": kygo_music,
  "kyle-hanagami-dance": kyle_hanagami_dance,
  "louis-bell-production": louis_bell_production,
  "mark-rober-engineering": mark_rober_engineering,
  "pasek-paul-musical-theatre": pasek_paul_musical_theatre,
  "pentatonix-a-cappella": pentatonix_a_cappella,
  "ryan-tedder-songwriting": ryan_tedder_songwriting,
  "shoe-surgeon-shoemaking": shoe_surgeon_shoemaking,
  "simone-giertz-building": simone_giertz_building,
  "stevie-mackey-singing": stevie_mackey_singing,
  "ten-hundred-painting": ten_hundred_painting,
  "valentines-day-baking-challenge": valentines_day_baking_challenge,
  "valentines-day-love-song-challenge": valentines_day_love_song_challenge,
  "vlogging-challenge": vlogging_challenge,
};

export const getNonChallengeFaqKeys = () =>
  Object.keys(FAQ_CONTENT).filter((key) => {
    return !key.toLowerCase().includes("challenge");
  });
export const getFaqKeyAndTitlesByKeys = (NON_CHALLENGE_FAQ_IDS: string[]): FAQKeyTitle[] =>
  NON_CHALLENGE_FAQ_IDS.map((key) => {
    return { key, title: FAQ_CONTENT[key as keyof typeof FAQ_CONTENT].title || "" };
  });

export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQContent {
  title: string;
  titleWithClassname?: string;
  callToActionText?: string;
  faq: FAQItem[];
}

export interface FAQData {
  [key: string]: FAQContent;
}

export interface FAQKeyTitle {
  key: string;
  title: string;
}

const faqData: { [key: string]: FAQContent } = FAQ_CONTENT;

export const getFaqContent = (key: string): FAQContent => faqData[key];
